import { render, staticRenderFns } from "./Geomoss.vue?vue&type=template&id=130afcd5&"
import script from "./Geomoss.vue?vue&type=script&lang=js&"
export * from "./Geomoss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports